import React from 'react';
import './App.css';

import LocationMap from './LocationMap';

function App() {
  const query = new URLSearchParams(window.location.search);
  const lngString: string = query.get('lng') ?? '10.3951';
  const lng: number = parseFloat(lngString);


  const latString: string = query.get('lat') ?? '63.4305';
  const lat: number = parseFloat(latString);

  const center = { lat, lng };
  return (
    <LocationMap locationDetails={center} />
  )
}

export default App;
